import { Box, Divider, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";

import { FcGridInfo } from "~/components/serviceSupport/FcGridInfo";
import {
  settingsPagePaddingSx,
  settingsSectionGap
} from "~/features/settings/settings.styles";

import { BinsOverviewSection } from "./components/BinsOverviewSection";
import { CubingSection } from "./components/CubingSection";
import { DangerZonesSection } from "./components/DangerZonesSection";
import { MaintenanceSection } from "./components/MaintenanceSection";

export function BinsSettingsView() {
  const { t } = useTranslation();

  const mainStack = (
    <Stack spacing={settingsSectionGap} sx={{ width: "100%" }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap={{ xs: "wrap", md: "nowrap" }}
        gap={1.5}
        sx={{ minWidth: 0, columnGap: 2 }}
      >
        <Typography
          variant="h5"
          component="h1"
          sx={{
            flex: "0 1 auto",
            minWidth: 0,
            fontWeight: 500,
            letterSpacing: 0
          }}
        >
          {t("bins")}
        </Typography>
        <Box
          sx={{
            flex: "1 1 auto",
            minWidth: 0,
            display: "flex",
            justifyContent: { xs: "flex-start", md: "flex-end" }
          }}
        >
          <FcGridInfo />
        </Box>
      </Stack>

      <BinsOverviewSection />

      <Divider sx={{ width: "100%" }} role="presentation" />

      <CubingSection />

      <Divider sx={{ width: "100%" }} role="presentation" />

      <MaintenanceSection />

      <Divider sx={{ width: "100%" }} role="presentation" />

      <DangerZonesSection />
    </Stack>
  );

  return (
    <Box id="bins-settings-view-root" sx={settingsPagePaddingSx}>
      {mainStack}
    </Box>
  );
}
